import { render, staticRenderFns } from "./AddBannerForm.vue?vue&type=template&id=05e5591f&scoped=true&"
import script from "./js/add-banner-form.js?vue&type=script&lang=js&"
export * from "./js/add-banner-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5591f",
  null
  
)

export default component.exports